// extracted by mini-css-extract-plugin
module.exports = {"switch":"ChecboxSwitch_switch__aT44V","slider":"ChecboxSwitch_slider__3EGqY","round":"ChecboxSwitch_round__1_7o6"};